import React, { useState } from "react";
import { Table } from "reactstrap";
// componentes
import ModalEditFlight from "./ModalEditFlight";
import DeleteButton from "../../../components/Buttons/DeleteButton";
//service
import { deleteFlight } from "../../../utils/services/flight";
// alerta
import SweetAlert from "react-bootstrap-sweetalert";

export default function TableFlight(props) {
  const { voo, idEvent, data } = props;
  // selecionado para ações
  const [flightSelected, setFlightSelected] = useState({});
  // modal
  const [modalEditFlight, setModalEditFlight] = useState(false);
  // alertas
  const [alertDelete, setAlertDelete] = useState(false);
  const [alertDeleteConfirmed, setAlertDeleteConfirmed] = useState(false);

  function formatData(startDate) {
    var data = new Date(startDate + "T00:00:00-03:00");
    var dia = String(data.getDate()).padStart(2, "0");
    var mes = String(data.getMonth() + 1).padStart(2, "0");
    var ano = data.getFullYear();
    var dataAtual = dia + "/" + mes + "/" + ano;

    return dataAtual;
  }

  async function confirmDelete() {
    await deleteFlight({
      jwt: "",
      id: flightSelected.id,
    }).then(() => {
      setAlertDelete(false);
      setAlertDeleteConfirmed(true);
      // atualizar tabela
      data();
    });
  }

  return (
    <>
      {modalEditFlight && (
        <ModalEditFlight
          isOpen={modalEditFlight}
          toggle={() => setModalEditFlight(false)}
          idEvent={idEvent}
          editFlight={flightSelected}
          data={data}
        />
      )}

      {alertDelete && (
        <SweetAlert
          title={`Deseja deletar o Voo de ${flightSelected.login.nome}?`}
          warning
          showCancel
          confirmBtnText="Sim"
          cancelBtnText="Não"
          confirmBtnBsStyle="success"
          cancelBtnBsStyle="danger"
          onConfirm={() => {
            confirmDelete();
          }}
          onCancel={() => setAlertDelete(false)}
        >
          <a>Você não poderá reverter essa ação.</a>
        </SweetAlert>
      )}

      {alertDeleteConfirmed && (
        <SweetAlert
          success
          title={"Sucesso"}
          onConfirm={() => {
            setAlertDeleteConfirmed(false);
          }}
        >
          Voo deletado com sucesso
        </SweetAlert>
      )}

      <div className="table-responsive">
        <Table className="table mb-0">
          <thead className="table-light">
            <tr>
              <th>Participante</th>
              <th>Companhia</th>
              <th>Origem</th>
              <th>Destino</th>
              <th>Data/hora embarque</th>
              <th>Data/hora chegada</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody>
            {voo &&
              voo
                ?.filter((vooData) => vooData.login.nome?.toLocaleLowerCase())
                ?.map((e, i) => (
                  <tr key={i}>
                    <td>{e.login.nome}</td>
                    <td>{e.company}</td>
                    <td>{e.origin}</td>
                    <td>{e.destination}</td>
                    <td>
                      {formatData(e.boardingdate)} {e.boardingtill}
                    </td>
                    <td>
                      {formatData(e.arrivaldate)} {e.arrivaltime}
                    </td>
                    <td>
                      <i
                        className="mdi mdi-pencil"
                        style={{
                          color: "green",
                          fontSize: 17,
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          setFlightSelected(e);
                          setModalEditFlight(true);
                        }}
                      />
                      <DeleteButton
                        onClick={() => {
                          setFlightSelected(e);
                          setAlertDelete(true);
                        }}
                      />
                    </td>
                  </tr>
                ))}
          </tbody>
        </Table>
      </div>
    </>
  );
}
